export enum ModelName {
    AdBreakInfo = 'AdBreakInfo',
    AdItem = 'AdItem',
    ContentPlaybackState = 'ContentPlaybackState',
    PlayerDom = 'PlayerDom',
    PlayerOptions = 'PlayerOptions',
    PresentationState = 'PresentationState',
}
